window.config = {
    "apiHost": {
        "US": "https://api-us.aosulife.com",
        "CN": "https://api-cn.aosulife.com",
        "EU": "https://api-eu.aosulife.com",
        "AP": "https://api-ap.aosulife.com",
        "OTHER": "https://api-us.aosulife.com"
    },
    "jsBridge": {
        "login": "glazero://jsbridge/account/loginByShopify",
        "setKeyValue": "glazero://jsbridge/common/setKeyValue",
        "getKeyValue": "glazero://jsbridge/common/getKeyValue",
        "getAccountInfo": "glazero://jsbridge/account/getinfo",
        "getShopifyToken": "glazero://jsbridge/account/getShopifyToken",
        "closeWebView": "glazero://jsbridge/page/closepage",
        "toast": "glazero://jsbridge/common/toast",
        "writeLog": "glazero://jsbridge/common/writelog",
        "hiddenLoading": "glazero://jsbridge/common/hiddenloading",
        "hiddenLoading": "glazero://jsbridge/common/hiddenloading",
        "setTitleText": "glazero://jsbridge/page/setTitleText",
        "setTitleStyle": "glazero://jsbridge/page/setPageStyle",
        "reportevent": "glazero://jsbridge/common/reportevent",
        "openH5url": "glazero://jsbridge/page/openurl",
        "getheaders": "glazero://jsbridge/network/getheaders",
        "getdev": "glazero://jsbridge/common/getenv"
    },
    "shopifyApi": "https://aosu-store.myshopify.com/api/2023-10/graphql.json",
    "h5host": "https://home.aosulife.com/web/device_store_app/",
    //"h5host": "https://home-test.aosulife.com/web/device_store_app/",
    "aosuhost": "https://www.aosulife.com",
    //"aosuhost": "https://pywpwgaqi2ow6vs7-61088301292.shopifypreview.com",
    "officialHost": "https://www.aosulife.com"
}
